var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.activeNewsletters),function(newsletterInfo){return _c('Newsletter',{attrs:{"data":newsletterInfo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }